<template>
  <!--
      	作者：gmshop
      	时间：2019-06-04
      	描述：插件中心-优惠券-发送优惠券
      -->
  <div class="user">
    
    <div class="product-content">
      <el-form ref="form" size="small" :model="form" label-width="150px">
        <div class="common-form">用户升级送优惠券</div>
        <el-form-item label="是否开启" prop="is_open"><el-switch v-model="form.is_open"></el-switch></el-form-item>
        <div  v-if="form.is_open" v-for="(item,index) in form.coupon" :key="index">
          <el-form-item >
            <el-checkbox  v-model="item.is_open">{{item.name}}</el-checkbox>
          </el-form-item>
          <el-form-item label="" v-if="item.is_open">
            <el-button type="primary" @click="openConpon('grade',index)">添加</el-button>
            <el-table :data="item.couponList" style="width: 60%">
              <el-table-column prop="coupon_id" label="优惠券id">
              </el-table-column>
              <el-table-column prop="name" label="优惠券">
              </el-table-column>
              <el-table-column prop="coupon_num" label="数量" :rules="[{required: true,message: ' '}]">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.coupon_num" placeholder="" min="1" max='10' @blur='max10'></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="delcoupon('grade',index,scope.row)"> 删除 </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>

        <div class="common-form">新人领券</div>
         <el-form-item label="是否开启" prop="is_open_new"><el-switch v-model="form.is_open_new"></el-switch></el-form-item>
        <el-form-item label="" v-if="form.is_open_new">
            <el-button type="primary" @click="openConpon('user')">添加优惠券</el-button>
            <el-table :data="form.new_user_coupon" style="width: 60%"  :key="index">
              
              <el-table-column prop="name" label="优惠券">
              </el-table-column>
              <el-table-column prop="type" label="类型">
              </el-table-column>
              <!-- <el-table-column prop="coupon_num" label="数量" :rules="[{required: true,message: ' '}]">
                <template slot-scope="scope">
                  <el-input type="number" v-model="scope.row.coupon_num" placeholder="" min="1" max='10' @blur='max10'></el-input>
                </template>
              </el-table-column> -->
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="delcoupon('user',index,scope.row)"> 删除 </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>



        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
    </div>



    <!--选择优惠券-->
    <GetCoupon v-if="open_coupon" :open_add="open_coupon" @closeDialog="closeCouponFunc($event, 'add')"></GetCoupon>
  </div>
</template>

<script>
import CouponApi from '@/api/coupon.js';

import GetCoupon from '@/components/coupon/GetCoupon.vue';
export default {
  components: {

    GetCoupon
  },
  data() {
    return {
      /*是否加载完成*/
      loading: false,
      /*表单数据对象*/
      form: {
        is_open:false,
        is_open_new:false,
        new_user_coupon:[],
        coupon:[],
      },

      /*是否显示获取优惠券*/
      open_coupon: false,
      index:null,
      type:'',

    };
  },
  created() {
    /*获取等级*/
    this.getGradeList();
  },
  methods: {
    /*获取等级*/
    getGradeList() {
      let self = this;
      CouponApi.getSetting({}, true)
        .then(data => {
          self.form.is_open = data.data.setting.is_open;
          self.form.is_open_new = data.data.setting.is_open_new;
          self.form.coupon = data.data.list;
          self.form.new_user_coupon = data.data.setting.new_user_coupon?data.data.setting.new_user_coupon:[];

          self.form.coupon.forEach(item=>{
            self.$set(item, 'couponList', [])
            self.$set(item, 'is_open', false)
            data.data.setting.coupon.forEach(item1=>{
              if(item1.grade_id == item.grade_id){
                self.$set(item, 'couponList', item1.couponList?item1.couponList:[])
                self.$set(item, 'is_open',item1.is_open?item1.is_open:false)
              }
            })
          })
        })
        .catch(error => {});
    },


    /*选择优惠券*/
    openConpon(type,index=0) {
      this.open_coupon = true;
      if(type=='grade'){
        this.index = index;
      }
      this.type=type;
      
    },
    delcoupon(type,index,item) {
      let self = this;
      if(type=='grade'){
        let n = self.form.coupon[index].couponList.indexOf(item);
        self.form.coupon[index].couponList.splice(n, 1);
      }else{
        self.form.new_user_coupon.splice(index,1)
      }
      

    },
    /*关闭优惠券*/
    closeCouponFunc(e) {
      let self = this;
      self.open_coupon = e.openDialog;

      if (e.type == 'success') {
        if(self.type=='grade'){
          if (self.form.coupon[self.index].couponList.length < 1) {
            self.form.coupon[self.index].couponList.push({
              coupon_id: e.params.coupon_id,
              coupon_num: 1,
              name: e.params.name,
            });

          } else {
            let flag = true;
            self.form.coupon[self.index].couponList.forEach((item, index) => {
              if (item.coupon_id == e.params.coupon_id) {
                flag = false
              }
            })
            if (flag) {
              self.form.coupon[self.index].couponList.push({
                coupon_id: e.params.coupon_id,
                coupon_num: 1,
                name: e.params.name,
              });

            } else {
              self.$message.error('请勿重复添加');
            }
          }
        }else{
          console.log(e.params)
          self.form.new_user_coupon.push({
            coupon_id: e.params.coupon_id,
            coupon_num: 1,
            name: e.params.name,
            type:e.params.coupon_type.text
          })
        }
        
      }
    },

    /*提交*/
    onSubmit() {
      let self = this;
      let params = self.form;
      //params.coupon = JSON.stringify(params.coupon);

      CouponApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '编辑成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    max10(e){
      if(e.target.value>=10){
        e.target.value=10
      }
    }
  }
};
</script>

<style scoped="scoped">
  .select-user li{ width: 30px;}
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/setting.vue